import(/* webpackMode: "eager" */ "/opt/cal.com.next/apps/web/app/global-error.tsx");
